'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
exports.mapMetaToQuestions = mapMetaToQuestions;
exports.mapMetaToGroups = mapMetaToGroups;
exports.mapMetaToAsyncValidate = mapMetaToAsyncValidate;
var _validators = require('../validators');
var _validators2 = _interopRequireDefault(_validators);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function transformQuestionToDisplay(question) {
  var questionsDisplay = _extends({}, question.attributes, {
    slug: question.id,
    type: question.attributes.component,
    isRequired: question.attributes.is_required,
    group: question.relationships.group && question.relationships.group.data.id
  });
  if (question.attributes.component === 'SelectQuestion') {
    questionsDisplay.choiceLabels = question.attributes.choice_labels;
  }
  if (question.attributes.component === 'toggle') {
    questionsDisplay.parse = function (value) {
      return value ? 'yes' : 'no';
    };
    questionsDisplay.format = function (value) {
      return value === 'yes';
    };
  }
  if (question.attributes.question_type === 'integer') {
    questionsDisplay.parse = function (value) {
      var parsedvalue = value && parseInt(value, 10);
      return Number.isInteger(parsedvalue) ? parsedvalue : null;
    };
  }
  if (question.attributes.validators) {
    questionsDisplay.validate = (0, _validators2.default)(question.attributes.validators);
  }
  return questionsDisplay;
}
function identity(question) {
  return question;
}
function mapMetaToQuestions(enrollmentMeta) {
  var questionFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
  var _enrollmentMeta$data = enrollmentMeta.data,
    relationships = _enrollmentMeta$data.relationships,
    id = _enrollmentMeta$data.id,
    included = enrollmentMeta.included;
  var questionIds = relationships.questions.data.map(function (question) {
    return question.id;
  });
  var questions = included.filter(function (resource) {
    return questionIds.includes(resource.id) && resource.type === id + '-questions';
  }).filter(function (question) {
    return question.attributes.is_asked !== false;
  }).filter(questionFilter);
  var questionDisplays = questions.map(transformQuestionToDisplay);
  return questionDisplays;
}
function mapMetaToGroups(enrollmentMeta) {
  var _enrollmentMeta$data2 = enrollmentMeta.data,
    relationships = _enrollmentMeta$data2.relationships,
    id = _enrollmentMeta$data2.id,
    included = enrollmentMeta.included;
  var groupIds = relationships.groups.data.map(function (group) {
    return group.id;
  });
  var groups = included.filter(function (resource) {
    return groupIds.includes(resource.id) && resource.type === id + '-groups';
  }).reduce(function (accum, group) {
    accum[group.id] = _extends({}, group.attributes);
    return accum;
  }, {});
  return groups;
}
function mapMetaToAsyncValidate(enrollmentMeta) {
  var _enrollmentMeta$data$ = enrollmentMeta.data.attributes;
  _enrollmentMeta$data$ = _enrollmentMeta$data$ === undefined ? {} : _enrollmentMeta$data$;
  var validators = _enrollmentMeta$data$.validators;
  return (0, _validators.generateCompositeAsyncValidator)(validators);
}